import type { SVGProps } from 'react';

export function WITHDRAW(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="currentColor">
        <path
          d="M0.952953 10.2264C0.692025 10.2264 0.467968 10.1195 0.280781 9.90566C0.0935936 9.69182 0 9.44025 0 9.15094V7.71698C0 7.42767 0.0935936 7.17924 0.280781 6.9717C0.467968 6.76415 0.692025 6.66038 0.952953 6.66038H13.4434C13.2733 6.71069 13.1088 6.77673 12.95 6.85849C12.7911 6.94025 12.6493 7.06918 12.5245 7.24528C12.1615 7.69811 11.7985 8.18553 11.4354 8.70755C11.0724 9.22956 10.7264 9.73585 10.3974 10.2264H0.952953ZM3.08008 5.45283C2.81915 5.45283 2.5951 5.34591 2.40791 5.13208C2.22072 4.91824 2.12713 4.66667 2.12713 4.37736V3.0566C2.12713 2.7673 2.22072 2.51887 2.40791 2.31132C2.5951 2.10377 2.81915 2 3.08008 2H16.03C16.291 2 16.5179 2.10377 16.7107 2.31132C16.9036 2.51887 17 2.7673 17 3.0566V4.37736C17 4.66667 16.9036 4.91824 16.7107 5.13208C16.5179 5.34591 16.291 5.45283 16.03 5.45283H3.08008ZM11.6737 13.7358V13.8868C11.6737 13.9623 11.6765 14.0849 11.6822 14.2547C11.6879 14.4245 11.6907 14.673 11.6907 15H0.952953C0.692025 15 0.467968 14.8962 0.280781 14.6887C0.0935936 14.4811 0 14.2264 0 13.9245V12.5094C0 12.2201 0.0935936 11.9717 0.280781 11.7642C0.467968 11.5566 0.692025 11.4528 0.952953 11.4528H9.54655C9.51251 11.478 9.48132 11.5126 9.45295 11.5566C9.42459 11.6006 9.39907 11.6352 9.37638 11.6604C9.26293 11.8365 9.19486 12.044 9.17217 12.283C9.14948 12.522 9.17217 12.7516 9.24024 12.9717C9.30831 13.1918 9.41892 13.3774 9.57207 13.5283C9.72523 13.6792 9.91525 13.7547 10.1421 13.7547H10.9419L11.6737 13.7358Z"
          fill="currentColor"
        />
        <rect x="13" y="10" width="3" height="7" fill="#D3D3D3" />
        <path
          d="M14.0985 7.54085C14.2984 7.27154 14.7016 7.27154 14.9015 7.54085L17.8047 11.452C18.0496 11.7819 17.8141 12.25 17.4033 12.25H11.5967C11.1859 12.25 10.9504 11.7819 11.1953 11.452L14.0985 7.54085Z"
          fill="#D3D3D3"
        />
      </g>
      <defs>
        <clipPath id="clip0_206_2319">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
